import { render, staticRenderFns } from "./AnesthesiaDetail.vue?vue&type=template&id=63371017&scoped=true"
var script = {}
import style0 from "./AnesthesiaDetail.vue?vue&type=style&index=0&id=63371017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63371017",
  null
  
)

export default component.exports